var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.25 3A.75.75 0 011 2.25h22a.75.75 0 010 1.5H1A.75.75 0 01.25 3zM.25 11a.75.75 0 01.75-.75h22a.75.75 0 010 1.5H1A.75.75 0 01.25 11zM.25 19a.75.75 0 01.75-.75h15.198a.75.75 0 010 1.5H1A.75.75 0 01.25 19z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 18a4 4 0 11-8 0 4 4 0 018 0zm-3.5.043v-1.747c0-.302-.224-.546-.5-.546s-.5.244-.5.546v1.932a.499.499 0 00.146.376l1 1a.5.5 0 00.708-.708l-.854-.853z",
    fill: "currentColor"
  })));
}

export default SvgHistory;